import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Money } from "../../../../../../../Wrap/Core/DataTypes/Money";
import { SectionHeader } from "../../../Common/SharedComponents";
import { incomePaymentDetailsLabels } from "../../Resource/Contents";

interface IPensionDetailsProps {
    data: any;
}

interface IPensionDetailsState {}

export class PensionDetails extends FormComponent<IPensionDetailsProps, IPensionDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { data } = this.props;
        return (
            <>
                {SectionHeader("Current income year")}
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.gadMaximum}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {this.getMoneyDisplay(data?.CurrentPensionYearGadMaximum)}
                    </span>
                </div>
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.pensionYearEndDate}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {JsonDateParser.getFormatDate(data?.PensionYearEndDate, "dd/MM/yyyy")}
                    </span>
                </div>
                <hr />
                {SectionHeader("New details available for review")}
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.totalPostRetirementAccountValue}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {this.getMoneyDisplay(data?.ValueUsedForReview)}
                    </span>
                </div>
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.expectedGadMaximum}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {this.getMoneyDisplay(data?.ExpectedGadMaximum)}
                    </span>
                </div>
            </>
        );
    }

    private getMoneyDisplay(data: Money) {
        return MoneyDisplayHelper.FromatMoneyDisplay(data?.Amount, data?.Currency || CurrencyCode.GBP);
    }
}
